
import React from 'react';
import { Check } from 'lucide-react';
import { TimeSlot } from '../../types';
import { cn } from '../../lib/utils';

interface TimeSlotItemProps {
  slot: TimeSlot;
  isSelected: boolean;
  onClick: () => void;
}

const TimeSlotItem: React.FC<TimeSlotItemProps> = ({ 
  slot, 
  isSelected, 
  onClick 
}) => {
  return (
    <div
      className={cn(
        "time-slot p-3 rounded-md border text-center cursor-pointer transition-all",
        "hover:border-teal-500 hover:shadow-sm flex flex-col items-center justify-center",
        isSelected ? "border-teal-500 bg-teal-50 shadow-sm" : "border-gray-200",
        !slot.available && "opacity-60 cursor-not-allowed bg-gray-50 hover:border-gray-200 hover:shadow-none"
      )}
      onClick={slot.available ? onClick : undefined}
      aria-disabled={!slot.available}
      role="button"
    >
      <span className="font-medium">{slot.time}</span>
      {slot.available ? (
        isSelected ? (
          <span className="text-xs mt-1 flex items-center justify-center gap-1 text-teal-700">
            <Check className="h-3 w-3" /> Selected
          </span>
        ) : (
          <span className="text-xs mt-1 text-teal-600">Available</span>
        )
      ) : (
        <span className="block text-xs mt-1 text-gray-500">Booked</span>
      )}
    </div>
  );
};

export default TimeSlotItem;
